import React, { Component, Fragment } from 'react'
import Select, { Creatable, Async } from 'react-select';
import classNames from 'classnames';
import ToolbarSimple from '../../../../Utils/Toolbar/ToolbarSimple';

import Grid from '../../../../Utils/Grid/index';
import Modal from 'react-responsive-modal';
import Switch from "react-switch";
import LoadMask from "Utils/LoadMask/LoadMask";
import {standardActions} from "../../../../Utils/Grid/StandardActions";
import { iconos } from '../../../../../../utility/icons';
import ReajusteForm from '../reajusteForm';
import { RenderNumber } from '../../../../Utils/renderField/renderReadField';
import { ESTADOS_EXISTENCIA } from '../../../../../../utility/constants';


function cellStyleMinimo(cell, row) {
    if (row.total_existencias > row.producto__minimo_existencias && row.total_existencias < (row.producto__minimo_existencias + row.producto__minimo_existencias * 0.30)) {
        return {color: "#F3A631", fontSize: 16, fontWeight: "bold", marginLeft: 15}
    }
    else if (row.total_existencias <= row.producto__minimo_existencias) {
        return {color: "#cc5729ff", fontSize: 16, fontWeight: "bold", marginLeft: 15}
    }
    else {}
}

function colEstadoStyle(cell, row) {
    if (row.estado_existencias === 2) {
        return `estado-reporte-${3}`
    }
    else if (row.estado_existencias === 3) {
        return `estado-reporte-${5}`
    }
    else null
}

export default class BodegaProduccionGrid extends Component {
    state = {
        producto: null,
    }
    componentDidMount(){
        this.props.getInventarioBodegaProduccion(1, this.props.idBodega)
    }

    pageChange = (page) => {
        this.props.getInventarioBodegaProduccion(page, this.props.idBodega)
    }

    /* componentWillMount() {
        const { leer, page, listDS } = this.props;
        leer(this.props.match.params.id);
        this.props.getDespachosPendientes(this.props.match.params.id);
        // lectura de los despachos

    } */

    searchInventario = (search) => {
        const tab = 2;
        this.props.searchChangeTransicion(search, this.props.match.params.id, tab);
    }

    botonRealizarReajusteMateriaPrima = (id, row) => {
        const producto = {
            id: row.producto__id,
            codigo: row.producto__codigo,
            nombre: row.producto__nombre,
            total_cantidad: row.total_cantidad,
            total_existencias: row.total_existencias,
            conversion: row.producto__conversion,
            unidad_medida: row.unidad_medida_display,
            empresa: {id: row.bodega__id},
        }

        return (
            <a className="px-2" style={{cursor: "pointer", color: "#c4183c"}} onClick={
                (e)=>{
                    e.preventDefault();
                    this.setState({producto: producto});
                    this.props.setOpenModalProd(true);
                }
            }>
                <img
                    className="action-img"
                    title="Reajustar o baja"
                    src={iconos.baja_reajuste}
                    alt="Reajustar o baja" />
            </a>
        )
    }

    handleSubmitReajusteProd = (values) => {
        let valores = _.cloneDeep(values);
        valores.cantidad = Number(values.cantidad);
        valores.bodega = Number(values.bodega);
        valores.tipo_movimiento = Number(values.tipo_movimiento);
        if (valores.vehiculo)
            valores.vehiculo = valores.vehiculo.id
        this.props.reajustarInventarioTransicion(valores, this.props.idBodega);
    }

    handleCheckedFilter = (value) => {
        this.props.setClaseProductoFilter(value, this.props.idBodega);
    };

    handleCheckedVendible = (value) => {
        this.props.setVendibleFilter(value, this.props.idBodega);
    };

    handleCheckedFacturado = (value) => {
        this.props.setFacturadoFilter(value, this.props.idBodega);
    };

    handleCheckedRepuesto = (value) => {
        this.props.setRepuestoFilter(value, this.props.idBodega);
    };

    handleSelectExistencias = (value) => {
        this.props.setExistenciasFilter(value, this.props.idBodega);
    };

    render() {
        const { idBodega, inventario_produccion, loader, listar: onPageChange, onSortChange, page_produccion, open_modal_prod,
            clase_producto_filter, vendible_filter, facturado_filter, repuesto_filter
        } = this.props;

        let valor = 1
        return (
            <Fragment>

                <Modal open={open_modal_prod}
                    classNames={{ modal: 'modal-xl', }}
                    onClose={(e) => {
                        this.props.setOpenModalProd(false);
                    }} center>
                    <div className="">
                        <h2 className="text-center text-primary text-uppercase">SELECCIONAR TIPO ACCIÓN</h2>
                    </div>
                    <ReajusteForm
                        producto={this.state.producto}
                        mostrarOpcionTrasladoProduccion={true}
                        initialValues={{
                            producto: this.state.producto ? this.state.producto.id : 0,
                            bodega: idBodega,
                            bodegaOrigen: 20, // Bodega de Producción
                            cantidad: this.state.producto ? this.state.producto.total_cantidad || this.state.producto.cantidad : 0,
                            volumen: this.state.producto ? this.state.producto.total_existencias || this.state.producto.cantidad : 0,
                            tipo_movimiento: "50"
                        }}
                        onSubmit={this.handleSubmitReajusteProd}
                        cerrarModal={() => {this.props.setOpenModalProd(false);}}
                    />
                </Modal>

                <div className="row col-md-12 m-0 p-0 d-flex justify-content-start">

                    {/* CLASE PRODUCTO */}
                    <div className="col-lg-3 col-md-3 col-12">
                        <div>
                            <input
                                type="radio"
                                className="btn-check"
                                name="opcionesClase"
                                id="opcion1"
                                autoComplete="off"
                                checked={clase_producto_filter === 0}
                                onChange={() => this.handleCheckedFilter(0)}
                            />
                            <label className="ml-1" htmlFor="opcion1"> Todo</label>
                        </div>

                        <div>
                            <input
                                type="radio"
                                className="btn-check"
                                name="opcionesClase"
                                id="opcion2"
                                autoComplete="off"
                                checked={clase_producto_filter === 10}
                                onChange={() => this.handleCheckedFilter(10)}
                            />
                            <label className="ml-1" htmlFor="opcion2">Materia Prima</label>
                        </div>

                        <div className="">
                            <input
                                type="radio"
                                className="btn-check"
                                name="opcionesClase"
                                id="opcion3"
                                autoComplete="off"
                                checked={clase_producto_filter === 20}
                                onChange={() => this.handleCheckedFilter(20)}
                            />
                            <label className="ml-1" htmlFor="opcion3">Producto Terminado</label>
                        </div>

                        <div className="">
                            <input
                                type="radio"
                                className="btn-check"
                                name="opcionesClase"
                                id="opcion4"
                                autoComplete="off"
                                checked={clase_producto_filter === 30}
                                onChange={() => this.handleCheckedFilter(30)}
                            />
                            <label className="ml-1" htmlFor="opcion4">Repuesto</label>
                        </div>
                    </div>

                    {/* VENDIBLE FILTER */}
                    <div className="col-lg-3 col-md-3 col-12">
                        <div>
                            <input
                                type="radio"
                                className="btn-check"
                                name="opcionesVendible"
                                id="opcion11"
                                autoComplete="off"
                                checked={vendible_filter === 0}
                                onChange={() => this.handleCheckedVendible(0)}
                            />
                            <label className="ml-1" htmlFor="opcion11">Vendible / No Vendible</label>
                        </div>

                        <div>
                            <input
                                type="radio"
                                className="btn-check"
                                name="opcionesVendible"
                                id="opcion22"
                                autoComplete="off"
                                checked={vendible_filter === 1}
                                onChange={() => this.handleCheckedVendible(1)}
                            />
                            <label className="ml-1" htmlFor="opcion22">No Vendible</label>
                        </div>

                        <div className="">
                            <input
                                type="radio"
                                className="btn-check"
                                name="opcionesVendible"
                                id="opcion33"
                                autoComplete="off"
                                checked={vendible_filter === 2}
                                onChange={() => this.handleCheckedVendible(2)}
                            />
                            <label className="ml-1" htmlFor="opcion33">Vendible</label>
                        </div>
                    </div>

                    {/* FACTURADO FILTER */}
                    <div className="col-lg-3 col-md-3 col-12">
                        <div>
                            <input
                                type="radio"
                                className="btn-check"
                                name="opcionesFacturado"
                                id="opcion111"
                                autoComplete="off"
                                checked={facturado_filter === 0}
                                onChange={() => this.handleCheckedFacturado(0)}
                            />
                            <label className="ml-1" htmlFor="opcion111">Facturado / No Facturado</label>
                        </div>

                        <div>
                            <input
                                type="radio"
                                className="btn-check"
                                name="opcionesFacturado"
                                id="opcion222"
                                autoComplete="off"
                                checked={facturado_filter === 1}
                                onChange={() => this.handleCheckedFacturado(1)}
                            />
                            <label className="ml-1" htmlFor="opcion222">No Facturado</label>
                        </div>

                        <div className="">
                            <input
                                type="radio"
                                className="btn-check"
                                name="opcionesFacturado"
                                id="opcion333"
                                autoComplete="off"
                                checked={facturado_filter === 2}
                                onChange={() => this.handleCheckedFacturado(2)}
                            />
                            <label className="ml-1" htmlFor="opcion333">Facturado</label>
                        </div>
                    </div>

                    <div className={"col-lg-3 col-md-6 col-12 align-self-start"}>
                        <span className="t-azul-claro font-weight-bold">Existencias</span>
                        <Select
                            isClearable={false}
                            className={classNames('react-select-container')}
                            backspaceRemovesValue={false}
                            isSearchable={true}
                            options={ESTADOS_EXISTENCIA}
                            placeholder={"Movimiento"}
                            defaultValue={ESTADOS_EXISTENCIA[0]}
                            onChange={(e) => {
                                this.handleSelectExistencias(e.value)
                            }}
                        />
                    </div>

                </div>

                <ToolbarSimple
                    textBoton={this.props.permisos.crear_editar_bodegas ? "Despachar" : undefined}
                    margen={"0"}
                    ruta={`/estado_bodega/crear/${this.props.match.params.id}`}
                    buscar={this.searchInventario}
                    buscador={this.props.search}
                    placeholder={"Buscar por: Nombre, Código"}
                    downloadButton={{
                        label: 'DESCARGAR',
                        handleDownload: this.props.permisos.crear_editar_bodegas ? this.props.descargaArchivoInventarioBodegaEP : undefined
                    }}
                    bodega_transicion={20}
                    permisos={true}
                />
                <br />
                <LoadMask loading={loader} light type={"TailSpin"}>
                    <Grid
                        data={inventario_produccion}
                        onPageChange={this.pageChange}
                        page={page_produccion}
                        hover
                        striped
                        loading={loader}
                        onSortChange={onSortChange}>
                        <TableHeaderColumn
                            dataField="producto__id"
                            dataAlign="center"
                            dataSort
                            isKey
                            width="5%"
                            dataFormat={
                                standardActions({ adicional: this.props.permisos.crear_editar_bodegas ? (id, row) => this.botonRealizarReajusteMateriaPrima(id, row) : undefined})
                            }
                        >
                        </TableHeaderColumn>
                        <TableHeaderColumn
                            dataField="producto__codigo"
                            dataSort
                        >
                            CÓDIGO
                        </TableHeaderColumn>
                        <TableHeaderColumn
                            dataField="total_cantidad"
                            dataSort
                            width="3%"
                            dataFormat = {(cell, row)=> <span className={colEstadoStyle(cell, row)} style={{margin:"0"}}></span>}
                        >
                        </TableHeaderColumn>
                        <TableHeaderColumn
                            dataField="producto__nombre"
                            dataSort
                        >
                            NOMBRE
                        </TableHeaderColumn>
                        <TableHeaderColumn
                            dataField="unidad_medida_display"
                            dataSort
                            dataFormat = {(cell, row) => cell.toUpperCase()}
                        >
                            UNIDAD MEDIDA
                        </TableHeaderColumn>
                        {/* <TableHeaderColumn
                            dataField="producto__conversion"
                            dataSort
                            // dataAlign="center"
                            dataFormat = {(cell, row)=> <RenderNumber value={ cell} decimalScale={4} />}
                        >
                            UNIDAD CONVERSIÓN
                        </TableHeaderColumn> */}
                        <TableHeaderColumn
                            dataField="total_cantidad"
                            dataSort
                            dataFormat = {(cell, row)=> <RenderNumber value={ cell} decimalScale={4} />}
                        >
                            CANTIDAD
                        </TableHeaderColumn>
                        <TableHeaderColumn
                            dataField="total_existencias"
                            dataSort
                            dataFormat = {(cell, row) => (
                                <div>
                                    <RenderNumber value={cell} decimalScale={4} /> {row.unidad_medida_display.toUpperCase()}
                                </div>
                            )}
                        >
                            EXISTENCIAS
                        </TableHeaderColumn>
                    </Grid>
                </LoadMask>
            </Fragment>

        );
    }
}
